import { ArrowLeft, ArrowRight } from "@phosphor-icons/react";
import type { ReactNode } from "react";

import { WorkspaceLink } from "./WorkspaceLink";

export function WorkspaceSetupDetail({
  children,
  description,
  eyebrow,
  title,
}: {
  children: ReactNode;
  description: string;
  eyebrow: string;
  title: string;
}) {
  return (
    <div className="workspace-setup-detail">
      <WorkspaceLink className="workspace-back-link" href="/app/setup">
        <ArrowLeft weight="bold" />
        Business setup
      </WorkspaceLink>
      <header className="workspace-setup-detail-header">
        <span className="workspace-eyebrow">{eyebrow}</span>
        <h1>{title}</h1>
        <p>{description}</p>
      </header>
      {children}
      <WorkspaceLink className="workspace-back-link" href="/app">
        Return to Overview
        <ArrowRight weight="bold" />
      </WorkspaceLink>
    </div>
  );
}
